import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

/**
 * Minimal cookie banner. Stores consent in localStorage as 'mv_cookie_consent'.
 * Values: 'accepted' | 'essential-only'. No cookies are set by MAVULA beyond
 * the auth cookie required for login (essential).
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("mv_cookie_consent")) {
        // slight delay so it doesn't fight with the auto-open chat
        const id = setTimeout(() => setVisible(true), 1500);
        return () => clearTimeout(id);
      }
    } catch {}
  }, []);

  const choose = (value) => {
    try { localStorage.setItem("mv_cookie_consent", value); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed z-40 bottom-4 left-1/2 -translate-x-1/2 w-[min(680px,calc(100%-2rem))] mv-card p-4 md:p-5 shadow-2xl"
      style={{ background: "linear-gradient(135deg, #fff, rgba(212,175,55,0.10))" }}
      role="dialog"
      aria-live="polite"
      data-testid="cookie-consent"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-2xl flex items-center justify-center mv-green-text shrink-0" style={{ background: "rgba(212,175,55,0.16)" }}>
          <Cookie size={20}/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display text-[16px] mv-green-text">Cookies — kept to a minimum.</div>
          <p className="text-[13px] mt-1" style={{ color: "var(--mv-muted)" }}>
            We use only the cookies we need to keep you signed in securely and to measure page views.
            No advertising trackers. No selling your data. Read our{" "}
            <Link to="/policies#cookies" className="underline mv-green-text font-semibold">Cookie Policy</Link>.
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            <button onClick={() => choose("accepted")} className="btn-green !py-2 !px-4 text-[13px]" data-testid="cookie-accept">
              Accept
            </button>
            <button onClick={() => choose("essential-only")} className="btn-ghost !py-2 !px-4 text-[13px]" data-testid="cookie-essential">
              Essential only
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
